const isPlainObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

const CORE_FIELDS = [
  'id','bookingId','bookingNumber','reference','organizationBookingReference','status','bookingSource','bookingChannel','privateBooking','visibility',
  'pickupArea','deliveryArea','vehicleType','vehicle_type','carType','carTypeName','car_image','carImage','bookingDate','bookingTime','pickupDate','pickupTime','deliveryDate','deliveryTime',
  'cargoCategory','cargoSummary','itemDescription','shipmentType','containerType','containerNumber','bookingType','deliveryWithBid','acceptedOfferType','selectedOfferId',
  'organizationId','organizationName','organizationClientRelationshipId','organizationClientNumber','clientAuthUid','clientProfileId','customer','customerUid',
  'fleetAdminUid','fleetadminUid','fleetadmin','acceptedFleetAdmin','assignedDriverUid','assignedDriver','driver','createdByUid','createdBy','createdByRole',
  'createdAt','updatedAt','bookingDateTime','scheduleDate','scheduleTime','tripdate','bookLater','booking_type_fleetadmin','booking_from_web','serverCreationRequestId','globalClientNumber','marketplaceStatus','requestedDrivers','fleetOffers','driverOffers','acceptedFleetOffer','acceptedDriverOffer',
  'acceptedDriver','assignedByFleetAdmin','assignedBy','assignedByRole','assignedAt','assignedVehicle','assignedVehicleName','assignedVehiclePlate',
  'driver_name','driverName','driver_image','vehicle_number','vehicleModel','vehicleMake','driverVehicleType','queue','slotMovementHistory','containerYardSlotRuleAdjustment',
  'deliveryInstructionsAcknowledged','driverStatus','workflowSource','workflowConfigId'
];

const ACCESS_FIELDS = [
  'organizationId','fleetAdminUid','fleetadminUid','fleetadmin','clientAuthUid','customer','customerUid','assignedDriverUid','assignedDriver','driver',
  'organizationClientRelationshipId','createdByUid','createdBy','createdByRole','bookingChannel','bookingSource','privateBooking','visibility','marketplaceStatus','deliveryWithBid','acceptedOfferType','acceptedFleetAdmin'
];

const OPERATION_FIELDS = [
  'pickup','drop','pickupAddress','dropAddress','pickupLat','pickupLng','dropLat','dropLng','pickupCoordinates','deliveryCoordinates','pickupCoords','dropCoords',
  'pickupInstructions','pickUpInstructions','deliveryInstructions','driverInstructions','tripInstructions','notes','note','specialInstructions','pickupNote','deliveryNote','cargoLength','cargoWidth','cargoHeight','cargoWeight',
  'grossWeight','numberOfPieces','pieces','cargoDimensions','cargoNote','itemDescription','serviceType','pickupDeliveryInfo','domesticBookingInfo','importBookingInfo','exportBookingInfo','shipmentType','containerNumber','additionalContainerNumbers','bookingNumber','bookingNumberExternal','blNumber','awbNumber','shippingLine',
  'containerSize','pickupPort','deliveryWarehouse','pickupContainerYardId','pickupContainerYardName','pickupContainerYardSlots','emptyReturnContainerYardId','emptyReturnContainerYardIds','emptyReturnContainerYardName','emptyReturnContainerYardSlots','yardGateStatus','yardGateRejectionReason','freeTimeExpiry','detentionDeadline','demurrageDeadline','dateConfirmationOk',
  'emptyReturnInfo','emptyPickupInfo','emptyPickUpContainer','emptyContainerReturns','emptyContainerReturnLastId','emptyContainerReturnLastStatus','emptyContainerReturnClosed','emptyContainerReturnAcceptedAt','detentionRemarks','arrivalProof','arrivalTime','arrivalTimestamp','arrivalLat','arrivalLng','arrivalTerminalGeofenceProof','arrivalProofHash',
  'trip_start_time','startTime','end_time','endTime','actuals','actualPickup','actualDelivery','geofenceProof','terminalGeofenceProof',
  'operationalContactName','operationalContactNumber','driver_contact','driver_phone','driver_token','assignedDriverContact'
];

const PRIVATE_FIELDS = [
  'clientId','clientName','clientContact','clientEmail','clientAddress','customer_name','customerName','customer_email','customerEmail','customer_phone','customerPhone',
  'customer_contact','customerContact','customer_token','customerToken','companyName','companyAddress','telephoneNumber','mobile','email','privateNotes','privateNote',
  'documents','documentMetadata','attachments','internalAttachments','sensitiveCargoNotes','clientCompanyName','clientCompanyAddress','billingAddress'
];

const CLIENT_CHARGE_FIELDS = [
  'truckingChargeToClient','clientCharge','clientTotal','approvedAdditionalFees','additionalFeesForClient','payment_status','paymentStatus','receiptNumber','receiptNo',
  'receiptSafeInfo','discount','cashPaymentAmount','cardPaymentAmount','payment_mode','paymentMode','trip_cost','estimate','estimateDistance','estimateTime'
];

const FINANCIAL_FIELDS = [
  'commission','commission_rate','commission_type','commissionRate','commissionType','commissionValue','convenience_fee_rate','convenience_fee_type','convenience_fees','convenienceFees','fleetCommission','fleet_admin_comission','garahexCommissionDeducted',
  'superAdminCommissionType','superAdminCommissionValue','superAdminCommissionAmount',
  'garahexCommissionDeductedAt','garahexCommissionDeductedFrom','garahexCommissionDeductedRole','garahexCommissionAmount','garahexCommissionBreakdown','garahexCommissionSource',
  'fleetAdminEarningRecorded','fleetAdminEarningRecordedAt','fleetAdminEarningGrossAmount','fleetAdminEarningCommissionAmount','fleetAdminEarningNetAmount','fleetAdminEarningAmount','fleetAdminEarningLedger',
  'driverEarningRecorded','driverEarningRecordedAt','driverEarningGrossAmount','driverEarningCommissionAmount','driverEarningNetAmount','driverEarningAmount','driverEarningLedger','driver_share',
  'driverPayoutHandledByFleetAdmin','walletThreshold','walletThresholdType','walletThresholdValue','walletBalanceAtBooking','walletThresholdRequiredAmount','walletThresholdPassed','walletReservation','walletReservedAmount',
  'internalCost','internalMarkup','profit','netAmount','fleetAdminNetAmount','additionalFees','additionalFeesBreakdown','totalAdditionalFees','totalAdditionalFeeAmount'
];

const MARKETPLACE_FIELDS = [
  'bookingId','bookingNumber','reference','pickupArea','deliveryArea','vehicleType','vehicle_type','carType','cargoCategory','cargoSummary','itemDescription','grossWeight','cargoWeight','numberOfPieces','pieces',
  'cargoLength','cargoWidth','cargoHeight','bookingDate','bookingTime','pickupDate','pickupTime','deliveryDate','deliveryTime','marketplaceStatus','deliveryWithBid','status','shipmentType'
];

const SENSITIVE_PATTERN = /(address|contact|email|mobile|phone|token|private|document|attachment|commission|earning|wallet|financial|charge|fee|profit|markup|cost|note|instruction|lat|lng|coordinate|pickup|drop|delivery)/i;

const unique = (items) => Array.from(new Set(items));
const ALL_SCOPED_FIELDS = unique([...OPERATION_FIELDS, ...PRIVATE_FIELDS, ...CLIENT_CHARGE_FIELDS, ...FINANCIAL_FIELDS]);

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);
const copyAllowlisted = (source, fields) => {
  const out = {};
  fields.forEach((field) => {
    if (hasOwn(source, field) && typeof source[field] !== 'undefined') out[field] = source[field];
  });
  return out;
};

const textFromLocation = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.add || value.address || value.description || value.name || '';
};

const generalArea = (value) => {
  const text = textFromLocation(value);
  if (!text) return '';
  return text.split(',').slice(-2).join(',').trim() || text;
};

const resolveAccess = (booking) => {
  const organizationId = booking.organizationId || booking.fleetadmin || booking.acceptedFleetAdmin || null;
  const fleetAdminUid = booking.fleetAdminUid || booking.fleetadminUid || booking.fleetadmin || booking.acceptedFleetAdmin || null;
  const clientAuthUid = booking.clientAuthUid || booking.customerUid || booking.customer || null;
  const assignedDriverUid = booking.assignedDriverUid || booking.assignedDriver || booking.driver || null;
  return {
    organizationId,
    fleetAdminUid,
    clientAuthUid,
    assignedDriverUid,
    organizationClientRelationshipId: booking.organizationClientRelationshipId || booking.relationshipId || booking.clientRelationshipId || booking.organizationRelationshipId || null,
    createdByUid: booking.createdByUid || booking.createdBy || null,
    createdByRole: booking.createdByRole || null,
    bookingChannel: booking.bookingChannel || null,
    bookingSource: booking.bookingSource || null,
    privateBooking: booking.privateBooking === true || booking.visibility === 'private' || booking.bookingSource === 'fleet_admin_client',
    marketplaceStatus: booking.marketplaceStatus || (booking.deliveryWithBid === true ? 'OPEN' : null)
  };
};

const buildCoreBooking = (booking, bookingId) => {
  const source = Object.assign({}, booking || {});
  const core = copyAllowlisted(source, CORE_FIELDS);
  core.bookingId = source.bookingId || bookingId;
  if (!core.id && source.id) core.id = source.id;
  const access = resolveAccess(source);
  if (access.organizationId && !core.organizationId) core.organizationId = access.organizationId;
  if (access.fleetAdminUid && !core.fleetAdminUid) core.fleetAdminUid = access.fleetAdminUid;
  if (access.clientAuthUid && !core.clientAuthUid) core.clientAuthUid = access.clientAuthUid;
  if (access.assignedDriverUid && !core.assignedDriverUid) core.assignedDriverUid = access.assignedDriverUid;
  if (access.organizationClientRelationshipId && !core.organizationClientRelationshipId) core.organizationClientRelationshipId = access.organizationClientRelationshipId;
  core.pickupArea = source.pickupArea || generalArea(source.pickup || source.pickupAddress);
  core.deliveryArea = source.deliveryArea || generalArea(source.drop || source.dropAddress || source.deliveryAddress);
  Object.keys(core).forEach((key) => { if (typeof core[key] === 'undefined') delete core[key]; });
  return core;
};

const buildBookingAccess = (booking, bookingId) => {
  const access = Object.assign({ bookingId }, copyAllowlisted(booking || {}, ACCESS_FIELDS), resolveAccess(booking || {}));
  Object.keys(access).forEach((key) => { if (typeof access[key] === 'undefined') delete access[key]; });
  return access;
};

const buildBookingOperations = (booking) => copyAllowlisted(booking || {}, OPERATION_FIELDS);
const buildBookingPrivate = (booking) => copyAllowlisted(booking || {}, PRIVATE_FIELDS);
const buildBookingClientCharges = (booking) => copyAllowlisted(booking || {}, CLIENT_CHARGE_FIELDS);
const buildBookingFinancials = (booking) => copyAllowlisted(booking || {}, FINANCIAL_FIELDS);

const buildBookingMarketplaceProjection = (booking, bookingId) => {
  const projection = copyAllowlisted(booking || {}, MARKETPLACE_FIELDS);
  projection.bookingId = (booking && booking.bookingId) || bookingId;
  projection.pickupArea = (booking && booking.pickupArea) || generalArea(booking && (booking.pickup || booking.pickupAddress));
  projection.deliveryArea = (booking && (booking.deliveryArea || generalArea(booking.drop || booking.dropAddress || booking.deliveryAddress))) || '';
  projection.marketplaceStatus = (booking && booking.marketplaceStatus) || ((booking && booking.deliveryWithBid === true) ? 'OPEN' : undefined);
  Object.keys(projection).forEach((key) => { if (typeof projection[key] === 'undefined' || projection[key] === '') delete projection[key]; });
  return projection;
};

const unknownSensitiveFields = (booking) => Object.keys(booking || {}).filter((key) => {
  if (CORE_FIELDS.indexOf(key) !== -1 || ALL_SCOPED_FIELDS.indexOf(key) !== -1 || MARKETPLACE_FIELDS.indexOf(key) !== -1 || ACCESS_FIELDS.indexOf(key) !== -1) return false;
  return SENSITIVE_PATTERN.test(key);
});

const splitBookingPayload = (booking, bookingId) => {
  const source = Object.assign({}, booking || {});
  const core = buildCoreBooking(source, bookingId);
  const access = buildBookingAccess(source, bookingId);
  const operations = buildBookingOperations(source);
  const privateData = buildBookingPrivate(source);
  const unknownFields = unknownSensitiveFields(source);
  unknownFields.forEach((field) => {
    if (hasOwn(source, field) && typeof source[field] !== 'undefined') privateData[field] = source[field];
  });
  const clientCharges = buildBookingClientCharges(source);
  const financials = buildBookingFinancials(source);
  const marketplace = source.deliveryWithBid === true || source.marketplaceStatus ? buildBookingMarketplaceProjection(source, bookingId) : {};
  const scopedFields = unique([...ALL_SCOPED_FIELDS, ...unknownFields])
    .filter((field) => !CORE_FIELDS.includes(field));
  return { bookingId, core, access, operations, privateData, clientCharges, financials, marketplace, scopedFields, unknownSensitiveFields: unknownFields };
};

const buildScopedAccessMetadata = (access) => {
  const metadata = {};
  ['bookingId','organizationId','fleetAdminUid','fleetadminUid','fleetadmin','clientAuthUid','customer','customerUid','assignedDriverUid','assignedDriver','driver','createdByUid','createdBy','createdByRole','organizationClientRelationshipId','bookingChannel','bookingSource','privateBooking','marketplaceStatus'].forEach((field) => {
    if (hasOwn(access, field) && typeof access[field] !== 'undefined' && access[field] !== null && access[field] !== '') metadata[field] = access[field];
  });
  return metadata;
};

const attachAccessMetadata = (value, access) => {
  if (!isPlainObject(value) || Object.keys(value).length === 0) return value;
  const metadata = buildScopedAccessMetadata(access);
  return Object.keys(metadata).length > 0 ? Object.assign({ _access: metadata }, value) : value;
};

const addFlatUpdates = (updates, targetPath, value) => {
  if (!isPlainObject(value)) return;
  Object.keys(value).forEach((key) => {
    if (typeof value[key] !== 'undefined') updates[targetPath + '/' + key] = value[key];
  });
};
const addIfNotEmpty = (updates, targetPath, value) => {
  if (isPlainObject(value) && Object.keys(value).length === 0) return;
  updates[targetPath] = value;
};

const buildOwnershipIndexUpdates = (bookingId, access, value = true) => {
  const updates = {};
  if (access.organizationId) updates['organizationOwned/' + access.organizationId + '/bookings/' + bookingId] = value;
  if (access.fleetAdminUid) updates['fleetAdminOwned/' + access.fleetAdminUid + '/bookings/' + bookingId] = value;
  if (access.clientAuthUid) updates['clientOwned/' + access.clientAuthUid + '/bookings/' + bookingId] = value;
  if (access.assignedDriverUid) updates['driverAssigned/' + access.assignedDriverUid + '/bookings/' + bookingId] = value;
  return updates;
};

const buildScopedBookingUpdate = (bookingId, booking, options = {}) => {
  const split = splitBookingPayload(booking, bookingId);
  const updates = {};
  const core = Object.assign({}, split.core);
  if (options.omitProtectedCoreOwnership === true) {
    [
      'organizationId','organizationName','organizationClientRelationshipId','organizationClientNumber',
      'clientAuthUid','clientProfileId','fleetadmin','fleetadminUid','fleetAdminUid',
      'createdBy','createdByUid','createdByRole'
    ].forEach((field) => { delete core[field]; });
  }
  updates['bookings/' + bookingId] = core;
  addIfNotEmpty(updates, 'bookingAccess/' + bookingId, split.access);
  addIfNotEmpty(updates, 'bookingOperations/' + bookingId, attachAccessMetadata(split.operations, split.access));
  addIfNotEmpty(updates, 'bookingPrivate/' + bookingId, attachAccessMetadata(split.privateData, split.access));
  addIfNotEmpty(updates, 'bookingClientCharges/' + bookingId, attachAccessMetadata(split.clientCharges, split.access));
  addIfNotEmpty(updates, 'bookingFinancials/' + bookingId, attachAccessMetadata(split.financials, split.access));
  addIfNotEmpty(updates, 'bookingMarketplace/' + bookingId, attachAccessMetadata(split.marketplace, split.access));
  if (options.includeIndexes !== false) Object.assign(updates, buildOwnershipIndexUpdates(bookingId, split.access, true));
  return { split, updates };
};

const buildScopedBookingPatchUpdate = (bookingId, bookingPatch, options = {}) => {
  const split = splitBookingPayload(bookingPatch, bookingId);
  const updates = {};
  const corePatch = copyAllowlisted(bookingPatch || {}, CORE_FIELDS);
  if (hasOwn(bookingPatch, 'pickup') || hasOwn(bookingPatch, 'pickupAddress')) corePatch.pickupArea = split.core.pickupArea;
  if (hasOwn(bookingPatch, 'drop') || hasOwn(bookingPatch, 'dropAddress') || hasOwn(bookingPatch, 'deliveryAddress')) corePatch.deliveryArea = split.core.deliveryArea;
  addFlatUpdates(updates, 'bookings/' + bookingId, corePatch);
  if (options.includeAccess !== false) addFlatUpdates(updates, 'bookingAccess/' + bookingId, split.access);
  addFlatUpdates(updates, 'bookingOperations/' + bookingId, attachAccessMetadata(split.operations, split.access));
  addFlatUpdates(updates, 'bookingPrivate/' + bookingId, attachAccessMetadata(split.privateData, split.access));
  addFlatUpdates(updates, 'bookingClientCharges/' + bookingId, attachAccessMetadata(split.clientCharges, split.access));
  addFlatUpdates(updates, 'bookingFinancials/' + bookingId, attachAccessMetadata(split.financials, split.access));
  addFlatUpdates(updates, 'bookingMarketplace/' + bookingId, split.marketplace);
  if (options.includeIndexes === true) Object.assign(updates, buildOwnershipIndexUpdates(bookingId, split.access, true));
  return { split, updates };
};
const buildScopedBookingCleanup = (bookingId, booking) => {
  const access = resolveAccess(booking || {});
  return Object.assign({
    ['bookingAccess/' + bookingId]: null,
    ['bookingOperations/' + bookingId]: null,
    ['bookingPrivate/' + bookingId]: null,
    ['bookingClientCharges/' + bookingId]: null,
    ['bookingFinancials/' + bookingId]: null,
    ['bookingMarketplace/' + bookingId]: null
  }, buildOwnershipIndexUpdates(bookingId, access, null));
};

export {
  CORE_FIELDS,
  ACCESS_FIELDS,
  OPERATION_FIELDS,
  PRIVATE_FIELDS,
  CLIENT_CHARGE_FIELDS,
  FINANCIAL_FIELDS,
  MARKETPLACE_FIELDS,
  splitBookingPayload,
  buildCoreBooking,
  buildBookingAccess,
  buildBookingOperations,
  buildBookingPrivate,
  buildBookingClientCharges,
  buildBookingFinancials,
  buildBookingMarketplaceProjection,
  buildScopedBookingUpdate,
  buildScopedBookingPatchUpdate,
  buildScopedBookingCleanup,
  buildOwnershipIndexUpdates,
  resolveAccess
};
